import { FxIdSdk } from "@fxid/sdk";
import { IFxIdSdkAdapterInviteFriendsRequest } from "@fxid/sdk-core";
import { closeModal } from "@mantine/modals";

const PLACEHOLDER_INVITE_TEXT = "";

export const inviteFriends = async (fxIdInstance: FxIdSdk | null | undefined) => {
	if (fxIdInstance == null) {
		log.warn("inviteFriends - fxidInstance is null");
		return;
	}

	const options: IFxIdSdkAdapterInviteFriendsRequest = { inviteText: PLACEHOLDER_INVITE_TEXT };
	closeModal("social");
	await fxIdInstance.InviteFriends(options);
};
